module.exports = "images/get-inspired-9.jpg";